@switch (columnName) {
  @case ('activePositionSelect') {
    <app-ui-select
      class="fixed-width"
      panelClass="full-width"
      [control]="element.positionControl"
      [options]="getJobPositionsForDepartment()"
      [isMultiple]="false"
      [required]="true"
      appStopClickPropagation
    ></app-ui-select>
  }
  @case ('currentActivityEndDate') {
    @if (element.currentActivityIsInfiniteEndDate) {
      {{ 'notDefined' | translate }}
    } @else {
      {{ element.currentActivityEndDate | date: dateTimeFormat }}
    }
  }
  @case ('userName') {
    @if (element.conflictingActivities.length > 0) {
      <mat-icon class="pointer">warning</mat-icon>
    }
    {{ element.userName }}
  }
  @default {
    <div [title]="element[columnName]">
      {{ element[columnName] }}
    </div>
  }
}
